export const SETUP_STEPS = [
  'Basic Information',
  'Tax',
  'Location',
  'Admin User',
  'Review',
] as const

export const BASIC_INFO_STEP = 0
export const TAX_STEP = 1
export const LOCATION_STEP = 2
export const ADMIN_STEP = 3
export const REVIEW_STEP = 4

export interface ClosedStepState {
  step: number
  locationAlreadyExists: boolean
  adminAlreadyExists: boolean
}

/**
 * Whether the step's record already exists, so what the form holds for it cannot
 * gate leaving it.
 */
export const isStepClosed = ({
  step,
  locationAlreadyExists,
  adminAlreadyExists,
}: ClosedStepState): boolean =>
  (step === LOCATION_STEP && locationAlreadyExists) ||
  (step === ADMIN_STEP && adminAlreadyExists)

export interface SetupProgress {
  hasOrganization: boolean
  hasLocation: boolean
  hasAdmin: boolean
}

/**
 * The step writing the first record the organization is missing. A resumed setup opens
 * here, and Back cannot reach behind it: a step that has committed its record is closed
 * for good, since there is no endpoint to amend it and re-submitting would create a
 * duplicate. Opening step and Back floor coincide only because no step can be left
 * without writing its record — a skippable step would separate them again.
 */
export const getFirstReachableStep = ({
  hasOrganization,
  hasLocation,
  hasAdmin,
}: SetupProgress): number => {
  if (!hasOrganization) {
    return BASIC_INFO_STEP
  }
  if (!hasLocation) {
    return LOCATION_STEP
  }
  if (!hasAdmin) {
    return ADMIN_STEP
  }
  return REVIEW_STEP
}
